module.exports = __webpack_public_path__ + "img/lost_or_found_screenshot.6619db86.jpg";